export default __webpack_public_path__ + "static/media/Market-Nalayisisi.4f4dee1c.png";